<div class="modal-header">
  <h4 class="modal-title pull-left"> Get Link </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
  <input type="text" class="form-control rounded-0" readonly/>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-rbv" (click)="onSubmit()">Copy</button>
</div>